export default {
  list: {
    page: 1,
    perPage: 10,
    sortKey: null,
    sortDirection: null,
    sortKeyDefault: null,
    sortDirectionDefault: null
  }
} as RetailMediaAdsState
